module.exports = __webpack_public_path__ + "static/wiczlinolot-704adb7b3bc8002f8214e357bd1e9704.jpg";